export default __webpack_public_path__ + "/dist/images/buy-icon.32063f5e1bbda5522b012b59acf02339.svg";